<script>
export default {
    name: "flash",
    data: function () {
        return {
            'visible': true,
        }

    },
}
</script>

